<template>
  <template v-if="notAvailable">
    <div class="grid-col">
      <div class="fs-36 fw-semibold fs-lg-28">Нет в наличии</div>
    </div>
  </template>

  <template v-else>
    <div v-if="getSelectedOffer?.price?.current" class="grid-col">
      <div class="fs-36 fw-bold fs-lg-28">
        {{ getSelectedOffer?.price?.current }} ₽
      </div>
    </div>
    <div class="grid-col" v-if="getSelectedOffer?.price?.old">
      <div class="price-old color-caption-soft fs-18 fs-lg-16">
        {{ getSelectedOffer?.price?.old }}
      </div>
    </div>
    <div class="grid-col" v-if="getSelectedOffer?.price?.old">
      <div
        class="label bg-fill-negative text-white fs-14 border-radius-sm px-8"
      >
        -{{ getSelectedOffer?.price?.discount }}%
      </div>
    </div>
  </template>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "OfferPrice",
  computed: {
    ...mapState(useProductStore, ["getSelectedOffer", "notAvailable"]),
  },
};
</script>
